/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckIdIsdoubleRequest as AgentApiContractCheckIdIsdoubleRequest } from '../../models/AgentApi/Contract/check-id-isdouble-request';

export interface ApiAgentCheckIdIsdoublePost$Params {

/**
 * ui language code.
 */
  lang?: string;
      body?: AgentApiContractCheckIdIsdoubleRequest
}

export function apiAgentCheckIdIsdoublePost(http: HttpClient, rootUrl: string, params?: ApiAgentCheckIdIsdoublePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentCheckIdIsdoublePost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentCheckIdIsdoublePost.PATH = '/api/Agent/CheckIdIsdouble';
